var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{on:{"addEvent":function($event){return _vm.$router.push({name: 'addCategories'})}}},[_vm._v(_vm._s(_vm.$t('main.sidebar.categories')))]),_c('main-table',{attrs:{"fields":_vm.fields,"list_url":'merchant/product-categories',"paginationName":"اقسام"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }